var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-input',_vm._g(_vm._b({directives:[{name:"mask",rawName:"v-mask",value:(_vm.appliedMask),expression:"appliedMask"}],model:{value:(_vm.phoneNumber),callback:function ($$v) {_vm.phoneNumber=$$v},expression:"phoneNumber"}},'vx-input',_vm.attrs,false),_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }